<ul class="support-contact-panel__list">
  <li *ngFor="let contact of contacts">
    <span class="support-contact-panel__name">{{ contact.name }}</span>
    <a class="support-contact-panel__phone" [href]="'tel:' + contact.phoneRaw">{{ contact.phone }}</a>
  </li>
</ul>
<p class="support-contact-panel__note">
  <span nz-icon nzType="environment" nzTheme="outline"></span>
  {{ officeNote }}
</p>
